export const NEWSLETTER = "NEWSLETTER";
